export default "__VITE_ASSET__c9d5132b__"